import { colors, screen } from 'components/styles/variables';

export interface PercentageBarProps {
  label: string;
  value: number;
}

export default function PercentageBar({ label, value }: PercentageBarProps): JSX.Element {
  return (
    <div className="percentage-bar-container">
      <div className="label-container">
        <div className="percentage-bar-label">{label}</div>
        <div className="percentage-bar-percentage">{`${value}%`}</div>
      </div>
      <div className="percentage-bar">
        <div className="grey-bar">
          <div className="filled-bar" />
        </div>
      </div>
      <style jsx>{`
        .percentage-bar-container {
          align-items: center;
          margin-bottom: 16px;
        }
        .label-container {
          display: flex;
          justify-content: space-between;
        }
        .percentage-bar-label,
        .percentage-bar-percentage {
          padding-right: 12px;
          font-weight: 600;
          letter-spacing: 0.2px;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 8px;
        }
        .percentage-bar-percentage {
          padding-right: 0;
        }
        .grey-bar {
          height: 12px;
          width: 252px;
          background: ${colors.G1};
          border: 1px solid ${colors.G2};
          border-radius: 4px;
          position: relative;
        }

        @media (min-width: ${screen.xsMax}) and (max-width: 849px) {
          .grey-bar {
            width: 468px;
          }
        }

        .filled-bar {
          height: 12px;
          width: ${value}%;
          border-radius: 4px 0 0 4px;
          position: absolute;
          top: -1px;
          left: -1px;
          background: ${colors.ALB1};
          border: 1px solid ${colors.ALB2};
        }
      `}</style>
    </div>
  );
}
